import { shouldShowSetupChecklist } from '@griply/utils';
import { useSetupChecklistState } from 'features/setup-checklist';
import React, { useRef } from 'react';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';
import { useTheme } from 'styled-components';

import { SetupChecklistContent } from './setup-checklist-content';

export const SetupChecklist: React.FC = () => {
  const user = useUser();
  const today = useToday();
  const theme = useTheme();
  const state = useSetupChecklistState(user?.uid);

  const everCompleteAtMount = useRef(state.everComplete).current;

  const shouldShow =
    !theme.isMobile &&
    shouldShowSetupChecklist({
      accountCreatedAtMs: user ? user.createdAt.getTime() : null,
      nowMs: today.getTime(),
      dismissed: state.dismissed,
      everComplete: everCompleteAtMount,
    });

  if (!shouldShow) {
    return null;
  }

  return <SetupChecklistContent state={state} />;
};
